export default function MySQL_NULLFUNCTIONS() {
  return (
    <div>
      <h2>MySQL_NULLFUNCTIONS</h2>    </div>
  );
}